import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { TAB_CONFIG, DEFAULT_TAB } from './tabs';

export function ProcurementIndexRedirect() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab');

  const match = tabParam
    ? TAB_CONFIG.find((tab) => tab.path === tabParam || tab.legacy === tabParam)
    : null;

  const target = match ?? DEFAULT_TAB;

  return <Navigate to={`/procurement/${target.path}`} replace />;
}
